<div class="g2p-wrapper">

  <!-- Left branding panel -->
  <div class="g2p-left">
    <div class="g2p-left-header">
      <div class="g2p-logo">G2</div>
      <span class="g2p-badge">
        <mat-icon>verified</mat-icon>
        Trusted Review Platform
      </span>
    </div>

    <h2 class="g2p-left-title">Share your<br>experience</h2>
    <p class="g2p-left-desc">
      Your honest review helps thousands of warehouses find the right WMS solution.
    </p>

    <div class="g2p-features">
      <div class="g2p-feature">
        <div class="g2p-feature-icon g2p-icon-purple">
          <mat-icon>star</mat-icon>
        </div>
        <div>
          <div class="g2p-feature-title">Help Others Decide</div>
          <div class="g2p-feature-desc">Your experience guides thousands choosing a WMS.</div>
        </div>
      </div>
      <div class="g2p-feature">
        <div class="g2p-feature-icon g2p-icon-green">
          <mat-icon>bar_chart</mat-icon>
        </div>
        <div>
          <div class="g2p-feature-title">Shape Our Product</div>
          <div class="g2p-feature-desc">Real feedback drives our roadmap and priorities.</div>
        </div>
      </div>
      <div class="g2p-feature">
        <div class="g2p-feature-icon g2p-icon-purple">
          <mat-icon>schedule</mat-icon>
        </div>
        <div>
          <div class="g2p-feature-title">Only 2 Minutes</div>
          <div class="g2p-feature-desc">Quick, honest, and genuinely impactful.</div>
        </div>
      </div>
    </div>

    <div class="g2p-star-card">
      <div class="g2p-star-card-logo">G2</div>
      <div class="g2p-star-card-stars">
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
        <mat-icon>star</mat-icon>
        <mat-icon>star_half</mat-icon>
      </div>
      <mat-icon class="g2p-star-card-trend">trending_up</mat-icon>
    </div>
  </div>

  <!-- Right action panel -->
  <div class="g2p-right">
    <button class="g2p-close" (click)="no()">
      <mat-icon>close</mat-icon>
    </button>

    <div class="g2p-right-body">
      <h3 class="g2p-right-title">Enjoying the WMS?</h3>
      <p class="g2p-right-desc">
        You've completed a lot of work here. If you have a moment, we'd love your honest review on G2 —
        it helps us keep making the product better for everyone.
      </p>
      <div class="g2p-secure">
        <mat-icon>shield</mat-icon>
        <div>
          <div class="g2p-secure-title">Secure &amp; Independent</div>
          <div class="g2p-secure-text">
            Your review goes directly to G2. We never see your response until it's published.
          </div>
        </div>
      </div>
    </div>

    <div class="g2p-right-actions">
      <button mat-button class="g2p-btn-cancel" (click)="no()">Maybe later</button>
      <button mat-flat-button class="g2p-btn-go" (click)="yes()">
        Rate us on G2
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>

</div>
